import get from 'lodash/fp/get';

import { BaseApiError } from '@lumapps/base-api';
import { getEvents } from '@lumapps/events/api/getEvents';
import { ListState } from '@lumapps/redux/genericListDucks';
import { BaseLoadingStatus } from '@lumapps/utils/types/BaseLoadingStatus';

import { actions } from '../slice';

export const fetchMoreEventList =
    ({ dispatchAction, state }: { dispatchAction: React.Dispatch<any>; state: ListState }) =>
    async () => {
        if (state.status === BaseLoadingStatus.idle) {
            const { cursor, hasMore, params } = state;
            if (!cursor || !hasMore) {
                return;
            }

            dispatchAction(actions.setStatus(BaseLoadingStatus.loadingMore));

            try {
                const result = await getEvents(params);
                const events = result.items;

                const ids = events.map(get('id'));

                dispatchAction(
                    actions.updateResult({
                        ids: ids as string[],
                        cursor: result.cursor,
                        hasMore: result.more,
                        items: events,
                        params,
                        append: true,
                    }),
                );

                dispatchAction(actions.setStatus(BaseLoadingStatus.idle));
            } catch (error) {
                if (error instanceof BaseApiError) {
                    if (error.response?.status === 404) {
                        dispatchAction(
                            actions.updateResult({
                                ids: [],
                                hasMore: false,
                                append: true,
                                items: [],
                                params,
                            }),
                        );
                        dispatchAction(actions.setStatus(BaseLoadingStatus.idle));
                    }
                }

                dispatchAction(actions.setStatus(BaseLoadingStatus.error));
            }
        }
    };
